<template>
  <div>
    <div class="mb-6">
      <em>{{ $t('components.materialTemplate.createModal.notImplemented') }}</em>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>
